import { string, func, bool } from "prop-types";

const Checkbox = ({ name, label, id, register, handleChange, disabled, ...props }) => {
  const {
    onChange: rhfOnChange,
    onBlur: rhfOnBlur,
    ref: rhfRef,
    name: rhfName,
  } = register && typeof register === "object" ? register : {};

  const changeHandler = (e) => {
    rhfOnChange?.(e);
    if (handleChange) {
      handleChange(name, e.target.checked);
    }
  };

  return (
    <label
      htmlFor={id}
      className="group flex items-center gap-3 cursor-pointer select-none"
    >
      <input
        id={id}
        type="checkbox"
        className={
          "h-4 w-4 shrink-0 rounded border border-input-border text-primary " +
          "transition-colors duration-fast " +
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 " +
          "checked:bg-primary checked:border-primary " +
          "disabled:cursor-not-allowed disabled:opacity-50"
        }
        name={rhfName || name}
        onChange={changeHandler}
        onBlur={rhfOnBlur}
        ref={rhfRef}
        disabled={disabled}
        {...props}
      />
      <span className="text-sm leading-5 text-foreground group-hover:text-foreground/80 transition-colors duration-fast">
        {label}
      </span>
    </label>
  );
};

Checkbox.propTypes = {
  name: string,
  id: string,
  label: string,
  handleChange: func,
  disabled: bool,
};

export default Checkbox;
